import { Box } from "@mui/material";

import { TypeHelper } from "@/common/helpers/type";
import { GeneralAttachmentDto } from "@/core/api/generated/v1";

import AttachmentsBriefInfoChip from "../../Files/AttachmentsBriefInfoChip";
import { defaultTableCellContentOfChipProps } from "./TableCellContentOfChip";

interface Props {
  attachments: GeneralAttachmentDto[] | undefined | null;
}

export default function TableCellContentOfAttachments({ attachments }: Props) {
  return (
    <Box>
      {TypeHelper.isEmpty(attachments) ? (
        "-"
      ) : (
        <AttachmentsBriefInfoChip
          attachments={attachments || []}
          chipProps={defaultTableCellContentOfChipProps}
        />
      )}
    </Box>
  );
}
